import { CTABox } from "/react4xp/parts/cta-box/cta-box";

export default (props) => <CTABox {...props} />